const env = (import.meta as any).env

export default {
  STRATA47_MB_ENV: env.STRATA47_MB_ENV,
  STRATA47_BP_TOKEN: env.STRATA47_BP_TOKEN,
  STRATA47_OMNIIQ_API: env.STRATA47_OMNIIQ_API,
  AUTH0_AUDIENCE: env.STRATA47_AUTH0_AUDIENCE,
  AUTH0_DOMAIN: env.STRATA47_AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: env.STRATA47_AUTH0_CLIENT_ID,
  AUTH0_ORGANIZATION: env.STRATA47_AUTH0_ORG,
}
